module.exports = __webpack_public_path__ + "assets/places_primary.93a05172.svg";